import _classCallCheck from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _inherits from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _wrapNativeSuper from "D:\\a\\1\\s\\Ktm.Configurator.Web\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
export var SessionNotAvailableError =
/*#__PURE__*/
function (_Error) {
  _inherits(SessionNotAvailableError, _Error);

  function SessionNotAvailableError(errorCode, m) {
    var _this;

    _classCallCheck(this, SessionNotAvailableError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SessionNotAvailableError).call(this, m));
    _this.errorCode = errorCode;
    Object.setPrototypeOf(_assertThisInitialized(_this), SessionNotAvailableError.prototype);
    return _this;
  }

  return SessionNotAvailableError;
}(_wrapNativeSuper(Error));
SessionNotAvailableError.E_NO_AVAILABLE = 'E_NO_AVAILABLE';
SessionNotAvailableError.E_NO_IMMEDIATE = 'E_NO_IMMEDIATE';
SessionNotAvailableError.E_NO_QUOTA = 'E_NO_QUOTA';
SessionNotAvailableError.E_NO_SIGNALING = 'E_NO_SIGNALING';
export var SessionProvisioningError =
/*#__PURE__*/
function (_Error2) {
  _inherits(SessionProvisioningError, _Error2);

  function SessionProvisioningError(data, m) {
    var _this2;

    _classCallCheck(this, SessionProvisioningError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SessionProvisioningError).call(this, m));
    Object.setPrototypeOf(_assertThisInitialized(_this2), SessionProvisioningError.prototype);
    _this2.data = data;
    return _this2;
  }

  return SessionProvisioningError;
}(_wrapNativeSuper(Error));
export var ReservationNotFoundError =
/*#__PURE__*/
function (_Error3) {
  _inherits(ReservationNotFoundError, _Error3);

  function ReservationNotFoundError(m) {
    var _this3;

    _classCallCheck(this, ReservationNotFoundError);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ReservationNotFoundError).call(this, m));
    Object.setPrototypeOf(_assertThisInitialized(_this3), ReservationNotFoundError.prototype);
    return _this3;
  }

  return ReservationNotFoundError;
}(_wrapNativeSuper(Error));
export var SessionNotFoundError =
/*#__PURE__*/
function (_Error4) {
  _inherits(SessionNotFoundError, _Error4);

  function SessionNotFoundError(m) {
    var _this4;

    _classCallCheck(this, SessionNotFoundError);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(SessionNotFoundError).call(this, m));
    Object.setPrototypeOf(_assertThisInitialized(_this4), SessionNotFoundError.prototype);
    return _this4;
  }

  return SessionNotFoundError;
}(_wrapNativeSuper(Error));
export var ConnectionKeyInUseError =
/*#__PURE__*/
function (_Error5) {
  _inherits(ConnectionKeyInUseError, _Error5);

  function ConnectionKeyInUseError(m) {
    var _this5;

    _classCallCheck(this, ConnectionKeyInUseError);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionKeyInUseError).call(this, m));
    Object.setPrototypeOf(_assertThisInitialized(_this5), ConnectionKeyInUseError.prototype);
    return _this5;
  }

  return ConnectionKeyInUseError;
}(_wrapNativeSuper(Error));
export var ArgumentsError =
/*#__PURE__*/
function (_Error6) {
  _inherits(ArgumentsError, _Error6);

  function ArgumentsError(m) {
    var _this6;

    _classCallCheck(this, ArgumentsError);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(ArgumentsError).call(this, m));
    Object.setPrototypeOf(_assertThisInitialized(_this6), ArgumentsError.prototype);
    return _this6;
  }

  return ArgumentsError;
}(_wrapNativeSuper(Error));
export var ConnectionCutType;

(function (ConnectionCutType) {
  ConnectionCutType[ConnectionCutType["BITRATE"] = 0] = "BITRATE";
  ConnectionCutType[ConnectionCutType["LATENCY"] = 1] = "LATENCY";
  ConnectionCutType[ConnectionCutType["FRAMES"] = 2] = "FRAMES";
})(ConnectionCutType || (ConnectionCutType = {}));

export var ConnectionCutError =
/*#__PURE__*/
function (_Error7) {
  _inherits(ConnectionCutError, _Error7);

  function ConnectionCutError(cutType, m) {
    var _this7;

    _classCallCheck(this, ConnectionCutError);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionCutError).call(this, m));
    Object.setPrototypeOf(_assertThisInitialized(_this7), ConnectionCutError.prototype);
    _this7.cutType = cutType;
    return _this7;
  }

  return ConnectionCutError;
}(_wrapNativeSuper(Error));
export var QuotaCheckError =
/*#__PURE__*/
function (_Error8) {
  _inherits(QuotaCheckError, _Error8);

  function QuotaCheckError(m) {
    var _this8;

    _classCallCheck(this, QuotaCheckError);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(QuotaCheckError).call(this, m));
    Object.setPrototypeOf(_assertThisInitialized(_this8), QuotaCheckError.prototype);
    return _this8;
  }

  return QuotaCheckError;
}(_wrapNativeSuper(Error));